/**
 * 选项的默认值
 */

export default {
  id: '',
  optionId: '',
  title: '',
  examplePhotos: [],
  exampleText: '',
  needPhoto: true,
  evidenceType: 'photo',
  forceCamera: true,
  referStepId: '',
  referIds: [],
  mStepDelay: '0',
  takePhotoAuxiliaryLine: 0,
  forcePanorama: false,
  exclusiveOption: [],
  titlePictures: [],
  required: true,
  inputType: 'text',
  inputMin: null,
  inputMax: null,
  settlementType: 0,
  settlementAmount: 0,
  settlementAmountRatio: 1,
  dataLabel: '',
  intelligentCall: false,
  autoIncreaseTaskGroupTarget: false,
  priorityReview: false,
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/recovery-fields/option.js